module.exports = __webpack_public_path__ + "img/local_set.639c67e0.svg";